import React from 'react';

import PropTypes from 'prop-types';

import { FormField } from 'components/FormHelper/FormField';

import { TENANT_WITH_BIRTHDATE } from 'global/constants';

import { getTenantId } from 'utils/tenantUtil';

export const DEBExpertPopupBaseInfoSection = ({ formik }) => {
  return (
    <>
      <div className="popup-content__popup-field">
        <FormField name="lastName" formik={formik} label="Nachname*" oldValue="" fullWidth />
      </div>
      <div className="popup-content__popup-field">
        <FormField name="firstName" formik={formik} label="Vorname*" oldValue="" fullWidth />
      </div>
      {TENANT_WITH_BIRTHDATE.includes(getTenantId()) && (
        <div className="popup-content__popup-field">
          <FormField name="birthdate" formik={formik} label="Geburtsdatum*" oldValue="" fullWidth />
        </div>
      )}
    </>
  );
};

DEBExpertPopupBaseInfoSection.propTypes = {
  formik: PropTypes.object.isRequired,
};
